import { useEffect, useState } from "react";
import React from "react";
export const ToggleButton = (props) => {
    const { Nav, links, error } = props;
    const [showNav, setShowNav] = useState(false);
    useEffect(() => {
        document.body.addEventListener("keydown", (e) => {
            if (e && e.keyCode === 27) {
                setShowNav(false);
            }
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { className: "side-nav-toggle" },
            React.createElement("a", { href: "/", title: "Navigation ein-/ausblenden", onClick: (e) => {
                    e.preventDefault();
                    setShowNav(!showNav);
                } },
                React.createElement("i", { className: "fas fa-bars" }))),
        showNav && (React.createElement("aside", { className: "side-nav" },
            React.createElement("div", { className: "side-nav-header" },
                React.createElement("button", { type: "button", className: "btn--link", onClick: () => setShowNav(false) },
                    "schlie\u00DFen",
                    React.createElement("i", { className: "fas fa-times ml2" }))),
            React.createElement(Nav, { links: links, error: error }))),
        showNav && (React.createElement("div", { className: "side-nav-layer", onClick: () => setShowNav(false) }))));
};
export default ToggleButton;
